import { connect } from 'react-redux';
import BulkDropZone from './BulkDropZone';
import { getTranslation } from "../../../reducers/common/localization";
import { uploadBulkAccreditationsAsJSON, uploadBulkAccreditationsAsFile } from "../../../reducers/accreditation/bulk";
import { getKey } from '../../../reducers/accreditation/certificate';
import { isAccreditationSigningRequired } from '../../../reducers/organization/organization';
import { fetchSubmitForm } from "../../../reducers/common/submitForm";
import { MODAL_SIGNING_ACCREDITATIONS_PROGRESS, showModal } from "../../../reducers/common/activeModal";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        signingKey: getKey(state),
        isSigningRequired: isAccreditationSigningRequired(state)
    };
};


const mapDispatchToProps = dispatch => {
    return {
        onUploadBulkAccreditationsAsFile: (data) => dispatch(uploadBulkAccreditationsAsFile(data)),
        onUploadBulkAccreditationsAsJSON: (data) => dispatch(uploadBulkAccreditationsAsJSON(data)),
        onSetLoading: () => {
            dispatch(fetchSubmitForm());
            dispatch(showModal({ modalKey: MODAL_SIGNING_ACCREDITATIONS_PROGRESS }));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkDropZone);



// WEBPACK FOOTER //
// ./src/components/commonComponents/bulkDropZone/BulkDropZone.container.js